import { createFileRoute } from "@tanstack/react-router";
import { Tv5UltraPage } from "@/components/products/Tv5UltraPage";
import { tv5UltraSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/products/inext-tv5-ultra")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => tv5UltraSeo(loaderData?.href ?? "/products/inext-tv5-ultra"),
  component: Tv5UltraPage,
});
